










































































import {Component, Vue} from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import IReservation from '@/interfaces/IReservation';
import StatusBadge from "@/components/StatusBadge.vue";
import SortIndicator from "@/components/SortIndicator.vue";
import ConfirmReservationModal from "@/components/ConfirmReservationModal.vue";
import IMessage from "@/interfaces/IMessage";
import MessageView from "@/components/MessageView.vue";

@Component({
	components: {
		MessageView,
		SortIndicator,
		StatusBadge,
		ConfirmReservationModal
	}
})
export default class ReservationsMessages extends Vue {
	public $http!: AxiosStatic;

	public showLoadingError: boolean = false;

	public loading: boolean = false;

	public messages: IMessage[] = [];
	public reservation: IReservation | null = null;

	public reservationId: number = 0;

	public async mounted() {
		this.reservationId = (<any>this.$route.params).id;
		await this.loadMessages();
		await this.markAllAsRead();
	}

	public get unreadMessages(): number {
		return this.messages.filter(message => message.read_state === 'unread').length;
	}

	public isFirstUnread(message: IMessage): boolean {
		if (message.read_state !== 'unread') {
			return false;
		}
		return message.id === this.messages.filter(msg => msg.read_state === 'unread')[0].id;
	}

	public async markMessagesAsUnread(messageId: number) {
		const index = this.messages.findIndex(message => message.id === messageId);
		await Promise.all(
			this.messages
				.map((message, i) => this.$http.put(`/private/message/${message.id}/read_state`, { read_state: i >= index ? 'unread' : 'read' }))
		);
		await this.loadMessages();
	}

	public async loadMessages() {
		this.loading = true;
		let url = `/private/reservation/${this.reservationId}/messages`;
		try {
			try {
				const response = await this.$http.get(url);
				this.messages = response.data;
			} finally {
				this.loading = false;
			}
			let reservation_url = `/private/reservation/${this.reservationId}`;
			const response = await this.$http.get(reservation_url);
			this.reservation = response.data;
		} catch(error) {
			this.showLoadingError = true;
		}
	}

	public async markAllAsRead() {
		await Promise.all(this.messages
			.filter(message => message.read_state === 'unread')
			.map(async message => this.$http.put(`/private/message/${message.id}/read_state`, { read_state: 'read' }))
		);
	}
}
